@if (isEmbedded$ | async) {
  <div class="main-content" semerisClosableInputController [ngClass]="breakPointId$ | async">
    <router-outlet></router-outlet>
  </div>
} @else {
  @if (appEnabled$ | async) {
    <semeris-sidenav [ngClass]="breakPointId$ | async"></semeris-sidenav>
    <main itemCartMediator semerisClosableInputController copyToController>
      <div class="semeris-header" [ngClass]="breakPointId$ | async">
        <semeris-toolbar [ngClass]="breakPointId$ | async"></semeris-toolbar>
      </div>
      <div class="main-content" [ngClass]="breakPointId$ | async">
        <router-outlet></router-outlet>
      </div>
    </main>
    <div class="help-sidebar-container">
      @if (helpOpen$ | async) {
        <semeris-help [mode]="helpMode$ | async"></semeris-help>
      }
      @if (conversationSidebarOpen$ | async) {
        <semeris-conversation-sidebar></semeris-conversation-sidebar>
      }
    </div>
    <semeris-tray>
      <ng-template #trayItem let-item="item" let-close="close" let-restore="restore">
        <div class="tray-item" (click)="restore(item)">
          {{ item.title }}
          <button semerisIconButton aria-label="Close" size="small" (click)="close(item)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </ng-template>
    </semeris-tray>
    <sui-overlay-outlet />
  }
}

